<template>
  <div class="cadastro-secoes">
    <v-card outlined class="mb-4 cadastro-bloco">
      <div class="cadastro-bloco__titulo d-flex align-center">
        <v-icon color="primary" class="mr-2">mdi-office-building</v-icon>
        <h2 class="text-h6 primary--text mb-0">Dados da Empresa</h2>
      </div>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="2">
            <v-switch
              v-model="value.flgEmpresaEstrangeira"
              true-value="S"
              false-value="N"
              label="Empresa estrangeira?"
              inset
              dense
              class="mt-0"
            />
          </v-col>          
          <v-col cols="12" md="5">
            <v-text-field label="* Razão Social"
                          dense
                          :rules="[
                              this.$validators.string.required,
                              v => this.$validators.string.greaterThanOrEquals(v, 1),
                              v => this.$validators.string.lessThanOrEquals(v, 200)
                          ]"
                          v-model.trim="value.razaoSocial"/>
          </v-col>
          <v-col cols="12" md="5">
            <v-text-field label="* Nome Fantasia"
                          dense
                          :rules="[
                              this.$validators.string.required,
                              v => this.$validators.string.greaterThanOrEquals(v, 1),
                              v => this.$validators.string.lessThanOrEquals(v, 200)
                          ]"
                          v-model.trim="value.nomeFantasia"/>
          </v-col>
          <v-col cols="12" md="12">
            <v-text-field v-if="empresaEstrangeira"
                          :label="labelCnpj"
                          :key="'cnpj-estrangeira'"
                          dense
                          maxLength="20"
                          :rules="rulesCnpj"
                          placeholder="Registro da empresa estrangeira"
                          v-model.trim="value.cnpj"/>
            <v-text-field v-else
                          :label="labelCnpj"
                          dense
                          :key="'cnpj-nacional'"
                          placeholder="99.999.999/9999-99"
                          :rules="rulesCnpj"
                          v-mask="'##.###.###/####-##'"
                          v-model.trim="value.cnpj"/>
          </v-col>
          <v-col cols="12">
            <v-textarea
              dense
              rows="6"
              label="* Descrição da Empresa"
              :rules="[
                  this.$validators.string.required,
                  v => this.$validators.string.greaterThanOrEquals(v, 1),
                  v => this.$validators.string.lessThanOrEquals(v, 4000),
              ]"
              v-model.trim="value.descricao"/>
          </v-col>
          <v-col cols="12" v-show="false">
            <search-box
                label="* Atividade Econômica"
                popup-label="Selecione um Atividade Econômica"
                :id.sync="value.idAtividadeEconomica"
                :descricao.sync="value.descricaoAtividadeEconomica"
                :hidden-clear="true"
                :value="atividadeEconomica"
                :loader-fn="loadeAtividadeEconomica"
                item-key="id"
                item-text="descricao"
                :rules="[
                    this.$validators.notNullOrUndefined
                ]">
              <template v-slot:empty>
                <p class="ma-2">
                  Nenhum Atividade Econômica encontrada
                </p>
              </template>
            </search-box>
          </v-col>          
        </v-row>
      </v-card-text>
    </v-card>

    <v-card outlined class="cadastro-bloco">
      <div class="cadastro-bloco__titulo d-flex align-center">
        <v-icon color="primary" class="mr-2">mdi-card-account-mail</v-icon>
        <h2 class="text-h6 primary--text mb-0">Contato, Localização e Responsáveis</h2>
      </div>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <h3 class="text-subtitle-1 primary--text">CONTATO</h3>
            <v-divider class="mb-4"/>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field label="Email"
                          dense
                          :rules="[
                            this.$validators.string.email,
                            v => this.$validators.string.lessThanOrEquals(v, 50),
                        ]"
                        v-model.trim="value.email"/>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field label="Telefone/Celular"
                          dense
                          v-mask="'(##) #####-####'"
                          v-model.trim="value.telefone"/>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field label="Site/Rede Social"
                          dense
                          v-model.trim="value.siteRede"/>
          </v-col>

          <v-col cols="12" class="mt-2">
            <h3 class="text-subtitle-1 primary--text">ENDEREÇO</h3>
            <v-divider class="mb-4"/>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field v-if="empresaEstrangeira"
                          :label="labelCep"
                          dense
                          :rules="rulesCep"
                          v-model.trim="value.cep"/>
            <v-text-field v-else
                          :label="labelCep"
                          dense
                          v-mask="'########'"
                          :rules="rulesCep"
                          v-model.trim="value.cep"/>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field label="* Cidade"
                          dense
                          :rules="[
                            this.$validators.string.required,
                            v => this.$validators.string.greaterThanOrEquals(v, 1),
                            v => this.$validators.string.lessThanOrEquals(v, 100),
                        ]"
                        v-model.trim="value.cidade"/>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field v-if="empresaEstrangeira"
                          :label="labelEstado"
                          dense
                          :rules="rulesEstado"
                          v-model.trim="value.estado"/>
            <lookup-dominio v-else
                            :label="labelEstado"
                            :hidden-clear="true"
                            v-model="value.estado"
                            :type="lookups.estado"
                            :rules="rulesEstado"/>
          </v-col>
          <v-col v-if="empresaEstrangeira" cols="12" sm="3">
            <v-text-field label="* País"
                          dense
                          :rules="rulesPais"
                          v-model.trim="value.pais"/>
          </v-col>
          <v-col cols="12" :sm="empresaEstrangeira ? 4 : 3">
            <v-text-field :label="labelBairro"
                          dense
                          :rules="[
                            this.$validators.string.required,
                            v => this.$validators.string.greaterThanOrEquals(v, 1),
                            v => this.$validators.string.lessThanOrEquals(v, 100),
                        ]"
                        v-model.trim="value.bairro"/>
          </v-col>
          <v-col cols="12" :sm="empresaEstrangeira ? 4 : 6">
            <v-textarea v-if="$vuetify.breakpoint.mobile"
                        dense
                        rows="3"
                        :label="labelEndereco"
                        :rules="[
                            this.$validators.string.required,
                            v => this.$validators.string.greaterThanOrEquals(v, 1),
                            v => this.$validators.string.lessThanOrEquals(v, 100),
                        ]"
                        v-model.trim="value.endereco"/>
            <v-text-field v-else :label="labelEndereco"
                          dense
                          :rules="[
                            this.$validators.string.required,
                            v => this.$validators.string.greaterThanOrEquals(v, 1),
                            v => this.$validators.string.lessThanOrEquals(v, 100),
                        ]"
                        v-model.trim="value.endereco"/>
          </v-col>
          <v-col cols="12" :sm="empresaEstrangeira ? 4 : 6">
            <v-textarea v-if="$vuetify.breakpoint.mobile"
                        dense
                        rows="3"
                        :label="labelComplemento"
                        :rules="[
                            v => this.$validators.string.greaterThanOrEquals(v, 1),
                            v => this.$validators.string.lessThanOrEquals(v, 100),
                        ]"
                        v-model.trim="value.complemento"/>
            <v-text-field v-else :label="labelComplemento"
                          dense
                          :rules="[
                              v => this.$validators.string.greaterThanOrEquals(v, 1),
                              v => this.$validators.string.lessThanOrEquals(v, 100),
                        ]"
                        v-model.trim="value.complemento"/>
          </v-col>
          <v-col cols="12" class="mt-2">
            <ResponsaveisInlineForm
              :tipo-contato="'COM'"
              :contatos="value.contatos"
              :empresa-estrangeira="empresaEstrangeira"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {ItemDeDominio} from "../../../api/itemsDominio";
import LookupDominio from "../common/LookupDominio";
import SearchBox from "../common/SearchBox";
import ResponsaveisInlineForm from "./ResponsaveisInlineForm";
import {buscaEnderecoViaCep} from '../../../api/correios';
//PKs
import {findAll as findAllAtividadeEconomica} from "../../../api/atividadeEconomica";

export default {
  name: "CompradorForm",
  components: {SearchBox, LookupDominio, ResponsaveisInlineForm},
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      lookups: {
        estado: ItemDeDominio.COMBO_ESTADO, 
      },
      loading: false,
      error: null,
    }
  },
  computed: {
    atividadeEconomica(){
      if (this.value.idAtividadeEconomica == null) return null;
      return {
        id: this.value.idAtividadeEconomica,
        descricao: this.value.descricaoAtividadeEconomica
      }      
    },
    empresaEstrangeira(){
      return this.value?.flgEmpresaEstrangeira === 'S';
    },
    labelCnpj(){
      return this.empresaEstrangeira ? '* Registro da empresa estrangeira' : '* CNPJ';
    },
    labelCep(){
      return this.empresaEstrangeira ? '* Código postal' : '* CEP';
    },
    labelEstado(){
      return this.empresaEstrangeira ? '* Estado/Província/Região' : '* Estado';
    },
    labelBairro(){
      return this.empresaEstrangeira ? '* Linha de endereço 1 (Bairro)' : '* Bairro';
    },
    labelEndereco(){
      return this.empresaEstrangeira ? '* Linha de endereço 2 (Endereço)' : '* Endereço';
    },
    labelComplemento(){
      return this.empresaEstrangeira ? 'Caixa postal / complemento' : 'Complemento';
    },
    rulesCnpj(){
      const rules = [this.$validators.string.required];
      if (!this.empresaEstrangeira) {
        rules.push(this.$validators.string.cnpj);
      } else {
        rules.push(v => this.$validators.string.greaterThanOrEquals(v, 1));
        rules.push(v => this.$validators.string.lessThanOrEquals(v, 20));
      }
      return rules;
    },
    rulesCep(){
      const rules = [this.$validators.string.required];
      if (!this.empresaEstrangeira) {
        rules.push(v => this.$validators.string.exactLength(v, 8));
      }
      return rules;
    },
    rulesEstado(){
      const rules = [this.$validators.string.required];
      if (this.empresaEstrangeira) {
        rules.push(v => this.$validators.string.greaterThanOrEquals(v, 1));
        rules.push(v => this.$validators.string.lessThanOrEquals(v, 100));
      }
      return rules;
    },
    rulesPais(){
      return [
        this.$validators.string.required,
        v => this.$validators.string.greaterThanOrEquals(v, 1),
        v => this.$validators.string.lessThanOrEquals(v, 100),
      ];
    },
  },
  watch: {
    'value.cep': {
      handler(newValue, oldValue) {
        this.buscaEndereco();
      }
    },
    'value.flgEmpresaEstrangeira': {
      handler(newValue) {
        if (!['S', 'N'].includes(newValue)) {
          this.$set(this.value, 'flgEmpresaEstrangeira', 'N');
          return;
        }
        if (newValue !== 'S') {
          this.$set(this.value, 'pais', '');
        }
      }
    }
  },
  methods: {
    garantirEstrutura() {
      if (!['S', 'N'].includes(this.value.flgEmpresaEstrangeira)) {
        this.$set(this.value, 'flgEmpresaEstrangeira', 'N');
      }
      if (this.value.pais == null) {
        this.$set(this.value, 'pais', '');
      }
      if (!Array.isArray(this.value.contatos)) {
        this.$set(this.value, 'contatos', []);
      }
    },
    async buscaEndereco(){
      if (this.empresaEstrangeira) return;
      if (this.value.cep !== "" && this.value.cep.length === 8){
        let endereco = await buscaEnderecoViaCep(this.value.cep);
        this.value.cidade = endereco.localidade;
        this.value.estado = endereco.uf;
        this.value.bairro = endereco.bairro;
        this.value.endereco = endereco.logradouro;
      }
    },
    loadeAtividadeEconomica(page, search) {
      return findAllAtividadeEconomica(page, {
        descricao: search
      })
    },
  },
  mounted() {
    this.garantirEstrutura();
  }
}
</script>

<style scoped>
.cadastro-bloco {
  border-color: #c8dced;
  overflow: hidden;
}

.cadastro-bloco__titulo {
  background: linear-gradient(90deg, rgba(22, 122, 188, 0.14) 0%, rgba(22, 122, 188, 0.05) 100%);
  border-bottom: 1px solid #dce9f4;
  padding: 14px 16px;
}

</style>